import {Directive, ElementRef, Input} from '@angular/core';
import {InputFinishedDirective} from './input-finished.directive';

@Directive({
  selector: '[tdoInput]'
})
export class TdoInputDirective {
  @Input() type: string = '';

  inputFinished: InputFinishedDirective;

  constructor(private elRef: ElementRef) {
    let value = elRef.nativeElement.value;
    this.inputFinished = new InputFinishedDirective(elRef);
    this.inputFinished.appInputFinished.subscribe((event) => {
      value = event;
      switch (this.type) {
        case 'email':
          this.validateEmail(value);
          break;
        case 'phone':
          this.validatePhone(value);
          break;
      }
    });

    setTimeout(() => {
      value = elRef.nativeElement.value;
      switch (this.type) {
        case 'email':
          this.validateEmail(value);
          break;
        case 'phone':
          this.validatePhone(value);
          break;
      }
    }, 5000);
  }

  validateEmail(input: string) {
    const inputElement = this.elRef.nativeElement as HTMLInputElement;
    const s = input;
    if (!s.includes('@') || !s.includes('.')) {
      // this.isInvalid = true;
      inputElement.style.background = 'rgba(255, 0, 0, 0.3)';
    } else {
      if (s.length - s.lastIndexOf('.') < 3) {
        // this.isInvalid = true;
        inputElement.style.background = 'rgba(255, 0, 0, 0.3)';
      } else {
        // this.isInvalid = false;
        inputElement.style.background = 'unset';
      }
    }
  }

  validatePhone(input: string) {
    const inputElement = this.elRef.nativeElement as HTMLInputElement;
    if (input.includes('_')) {
      inputElement.style.background = 'rgba(255, 0, 0, 0.3)';
    } else {
      inputElement.style.background = 'unset';
    }
  }
}
